// 商品標籤

interface Props {
    type: number;
    categoryName?: string;
}

const ItemTags = ({ type, categoryName }: Props) => {
    if (type && type !== 4)
        return (
            <div className="flex items-center gap-x-0.5 text-[#fff] text-btn2 *:rounded-sm *:px-6 *:py-3">
                {/* 商品標籤 */}
                {categoryName && <span className="bg-black text-white">{categoryName}</span>}

                {/* 商品類別 */}
                <span className="bg-vPurple">{type === 1 ? '實體' : '虛擬'}</span>
            </div>
        );
};

export default ItemTags;
